import { useState } from "react";
import { api } from "./api";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await api.login(email, password);
      onLogin(data);
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", background: "#080c08", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Mono', monospace", padding: 16, boxSizing: "border-box" }}>
      <div style={{ width: "100%", maxWidth: 380, padding: "48px 40px", background: "#0d120d", border: "1px solid #1a2a1a", borderRadius: 2, boxSizing: "border-box" }}>
        <div style={{ marginBottom: 40 }}>
          <div style={{ fontSize: 11, letterSpacing: 4, color: "#34d399", textTransform: "uppercase", marginBottom: 8 }}>ZER0 INTERNAL</div>
          <div style={{ fontSize: 24, color: "#e8f5e8", fontWeight: 300, letterSpacing: -0.5 }}>Dashboard</div>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="login-email" style={{ display: "block", fontSize: 10, color: "#4a6a4a", letterSpacing: 2, marginBottom: 6, textTransform: "uppercase" }}>Email</label>
          <input id="login-email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()}
            style={{ width: "100%", background: "#111811", border: "1px solid #1e2e1e", borderRadius: 2, padding: "10px 12px", color: "#c8e6c8", fontSize: 13, outline: "none", boxSizing: "border-box" }}
            placeholder="admin@zer.com" />
        </div>
        <div style={{ marginBottom: 24 }}>
          <label htmlFor="login-password" style={{ display: "block", fontSize: 10, color: "#4a6a4a", letterSpacing: 2, marginBottom: 6, textTransform: "uppercase" }}>Contraseña</label>
          <input id="login-password" type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()}
            style={{ width: "100%", background: "#111811", border: "1px solid #1e2e1e", borderRadius: 2, padding: "10px 12px", color: "#c8e6c8", fontSize: 13, outline: "none", boxSizing: "border-box" }}
            placeholder="••••••••" />
        </div>
        {error && <div style={{ fontSize: 12, color: "#f87171", marginBottom: 16 }}>{error}</div>}
        <button onClick={handleSubmit}
          style={{ width: "100%", padding: "11px", background: "#1a3a1a", border: "1px solid #34d399", borderRadius: 2, color: "#34d399", fontSize: 12, letterSpacing: 2, textTransform: "uppercase", cursor: "pointer", opacity: loading ? 0.6 : 1 }}>
          {loading ? "Verificando..." : "Ingresar"}
        </button>
      </div>
    </div>
  );
}
